const {
  compare
} = require('semver/preload');

/**
 *  Find all the migration semver versions in the format.
 */
const getMigrationVersions = format => {
  let versions = [];

  // convert to a string and look for a regex of migrateVersion_*
  const formatString = JSON.stringify(format);
  const matches = formatString.match(/migrateVersion_[0-9]+\.[0-9]+\.[0-9]+/g);
  if (matches && matches.length > 0) {
    // sort according to semver.
    versions = matches.map(m => m.substring('migrateVersion_'.length)).sort(compare);
    // make discrete
    versions = [...new Set(versions)];
  }
  return versions;
};
module.exports = {
  getMigrationVersions
};